<template>
  <div class="alerte-facture">
    <v-alert outlined text type="success" v-if="estPayee && typeFacture == 'Cotisation'"
      >Votre facture est payée. Les détails de la récupération de votre carte de membre, si applicable,
      et reçus fiscaux sont dans le courriel "OTSTCFQ - Inscription au tableau confirmée".
      Vous pouvez fermer le navigateur ou <a :href="urlExtranet">cliquez ici</a> pour retourner à Mon Espace.</v-alert
    >
    <v-alert outlined text type="success" v-else-if="estPayee && typeFacture == 'DemandeAdmission'">
      Votre facture est payée, merci! Vous pouvez imprimer cette page comme preuve de paiement.
      Consulter <a :href="urlExtranet">Mon Espace</a> pour obtenir votre facture.</v-alert
    >
    <v-alert outlined text type="warning" v-if="estPayeeEnPartie"
      >Facture payée en partie. Veuillez payer le solde.</v-alert
    >
    <v-alert outlined text type="error" v-if="estAPayer"
      >Facture à payer.</v-alert
    >
    <v-alert outlined text type="info" v-if="facture.jetonDeFacturation">
      Échéancier des prélèvements enregistré. Aucune action requise. Vous pouvez retourner sur 
      <a :href="urlExtranet">Mon Espace</a>
      , fermer la fenêtre ou 
      <a @click="supprimerCartePaiement">changer ma carte de paiement</a>.
    </v-alert>
    <v-alert outlined text type="error" v-if="facture.erreur"
      >Le paiement de votre facture a échoué. Veuillez réessayer ou contacter
      l'OTSTCFQ</v-alert
    >
  </div>
</template>

<script>
import {getExtranetUrl} from "@/utils/stringUtils"

export default {
  props: {
    facture: Object,
    typeFacture: String,
  },
  data() {
    return {
      urlExtranet: getExtranetUrl(process.env.VUE_APP_HOME_XTRANET),
    }
  },
  computed: {
    estPayee() {
      return (
        this.facture.solde < 0.01 ||
        (this.facture.dejaPaye > 0 &&
          this.facture.dejaPaye == this.facture.total)
      );
    },
    estPayeeEnPartie() {
      return (
        this.facture.solde >= 0.01 &&
        this.facture.dejaPaye > 0.01 &&
        this.facture.dejaPaye != this.facture.total
      );
    },
    estAPayer() {
      return (
        this.facture.solde >= 0.01 &&
        this.facture.dejaPaye < 0.01 &&
        !this.facture.jetonDeFacturation
      );
    },
  },
  methods: {
    // Notifie le composant parent de supprimer la carte de paiement.
    supprimerCartePaiement() {
      this.$emit("deleteCard")
    }
  }
};
</script>

<style>
</style>